import { createContext, type ReactNode, useContext } from "react";

import type { AtlasHubServices } from "./types.js";

const AtlasHubContext = createContext<AtlasHubServices | null>(null);

export function AtlasHubProvider({
  value,
  children,
}: {
  value: AtlasHubServices;
  children: ReactNode;
}) {
  return <AtlasHubContext.Provider value={value}>{children}</AtlasHubContext.Provider>;
}

/**
 * Read the hub-injected `AtlasHubServices` port (ADR-0101 Phase 3). Every
 * Atlas component that needs a hub-owned domain (auth, help, board /
 * projects / workspaces / engagement / tenants / messages / notes) calls
 * this instead of importing `packages/web/src/**` directly.
 */
export function useAtlasHub(): AtlasHubServices {
  const ctx = useContext(AtlasHubContext);
  if (!ctx) {
    throw new Error("useAtlasHub must be used within <AtlasHubProvider>");
  }
  return ctx;
}
